import { Snippet } from "models";
import config from "../config";

const getExternalJs = (jsCode: string) => {
    const matches = jsCode.match(/\/\*\s*--externalJs (.)+\*\//gi);
    if (!matches) {
        return [];
    }
    return matches.map(m => m.replace(/^\/\*\s*--externalJs\s*/, "").replace(/\s*\*\/$/, ""));
};

const getExternalCss = (jsCode: string) => {
    const matches = jsCode.match(/\/\*\s*--externalCss (.)+\*\//gi);
    if (!matches) {
        return [];
    }
    return matches.map(m => m.replace(/^\/\*\s*--externalCss\s*/, "").replace(/\s*\*\/$/, ""));
};

const getDependencies = (
    generation: string,
    widgets: {name: string, version: string}[],
    externalJs: string[],
    externalCss: string[]
) =>
    `<style>html, body{height: 100%;}</style>
    <script type=\"text/javascript\" src=\"/codebase/data/demodata.js\"></script>` +
    widgets.map(w =>
        `${externalJs.length ? "" : `<script type="text/javascript" src="//cdn.dhtmlx.com/${w.name}/${w.version}.js?${generation}"></script>`}
        ${externalCss.length ? "" : `<link rel="stylesheet" type="text/css" href="//cdn.dhtmlx.com/${w.name}/${w.version}.css?${generation}">`}`
    ).join("\n") +
    externalJs.map(exJs => `<script type="text/javascript" src="${exJs}"></script>`).join("\n") +
    externalCss.map(exCss => `<link rel="stylesheet" type="text/css" href="${exCss}" />`).join("\n");

export function getPreviewContent({ jsCode, htmlCode, jsSettings }: Snippet) {
    const externalJsLinks = getExternalJs(jsCode);
    const externalCssLinks = getExternalCss(jsCode);

    return `
    <!doctype html>
    <html>
    <head>
        ${getDependencies(config.generation, jsSettings.widgets, externalJsLinks, externalCssLinks)}
    </head>
    <script>
        window.addEventListener("error", function(ev){
            top.postMessage({ type:"snippet-error", text: ev.message, line: ev.lineno }, "*");
        }, false);
    </script>
    <body style="height: 100%; margin: 0;">
        ${htmlCode.replace(/\$/g, "$$")}
        <script>
            ${jsCode.replace(/\$/g, "$$")}
        </script>
    </body>
    </html>`;
}
